<template>
  <!-- <b-card class="presales-pipeline" v-if="hasRight(user, 'dashboard', 'view')" no-body>
    <template #header>
      <h6 class="mb-0">PRESALES PIPELINE</h6>
    </template>
    <b-card-body> -->
      <b-row>
        <b-col cols="4" sm="4" md="4">
          <presales-progress-card
            title="Total Leads"
            :value="pipelineData.total_leads.count"
            :subtitle="`New: ${pipelineData.total_leads.new_leads}, Existing: ${pipelineData.total_leads.existing_leads}`"
            :progressPercentage="pipelineData.total_leads.progress_percentage"
            color="light-blue darken-1"
            clickable
            @click.native="$emit('presales-card-click', 'total_leads')"
          />
        </b-col>
        <b-col cols="4" sm="4" md="4">
          <presales-progress-card
            title="Total Calls Done"
            :value="pipelineData.total_calls_done.count"
            :progressPercentage="pipelineData.total_calls_done.progress_percentage"
            color="teal darken-1"
            clickable
            @click.native="$emit('presales-card-click', 'total_calls_done')"
          />
        </b-col>
        <b-col cols="4" sm="4" md="4">
          <presales-progress-card
            title="Connected Calls"
            :value="pipelineData.connected_calls.count"
            :progressPercentage="pipelineData.connected_calls.conversion_rate"
            subtitle="Conversion Rate"
            color="amber darken-1"
            clickable
            @click.native="$emit('presales-card-click', 'connected_calls')"
          />
        </b-col>
        <b-col cols="4" sm="4" md="4">
          <presales-progress-card
            title="Interested Leads"
            :value="pipelineData.qualified_interested_leads.count"
            :progressPercentage="pipelineData.qualified_interested_leads.conversion_rate"
            subtitle="Conversion Rate"
            color="purple darken-1"
            clickable
            @click.native="$emit('presales-card-click', 'qualified_interested_leads')"
          />
        </b-col>
        <b-col cols="4" sm="4" md="4">
          <presales-progress-card
            title="In Progress Leads"
            :value="pipelineData.in_progress_leads.count"
            :progressPercentage="pipelineData.in_progress_leads.conversion_rate"
            subtitle="Conversion Rate"
            color="indigo darken-1"
            clickable
            @click.native="$emit('presales-card-click', 'in_progress_leads')"
          />
        </b-col>
        <b-col cols="4" sm="4" md="4">
          <presales-progress-card
            title="Site Visit Interested"
            :value="pipelineData.site_visit_interested.count"
            :progressPercentage="pipelineData.site_visit_interested.conversion_rate"
            subtitle="Conversion Rate"
            color="deep-orange darken-1"
            clickable
            @click.native="$emit('presales-card-click', 'site_visit_interested')"
          />
        </b-col>
      </b-row>
    <!-- </b-card-body>
  </b-card>
</template> -->
</template>

<script>
import PresalesProgressCard from './PresalesProgressCard.vue';
import { BRow, BCol, BCard, BCardBody } from 'bootstrap-vue';
import { hasRight } from '@/utils/auth';
import { dashboardGet } from './dashboardApi';

export default {
  name: 'PresalesPipeline',
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    PresalesProgressCard,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
    dashboardData: { type: Object, default: null },
    useAggregate: { type: Boolean, default: false },
    baseApi: {
      type: String,
      default: () => process.env.VUE_APP_APIENDPOINT || '',
    },
    accessToken: {
      type: String,
      default: () => localStorage.getItem('accessToken') || '',
    },
  },
  data() {
    return {
      pipelineData: {
        total_leads: { count: 0, new_leads: 0, existing_leads: 0, progress_percentage: null },
        total_calls_done: { count: 0, progress_percentage: null },
        connected_calls: { count: 0, conversion_rate: null },
        qualified_interested_leads: { count: 0, conversion_rate: null },
        in_progress_leads: { count: 0, conversion_rate: null },
        site_visit_interested: { count: 0, conversion_rate: null },
      },
    };
  },
  watch: {
    dashboardData: { deep: true, handler(v) { if (v && v.presales_pipeline != null && hasRight(this.user, 'dashboard', 'view')) this.pipelineData = { ...this.pipelineData, ...v.presales_pipeline }; } },
    filters: {
      deep: true,
      immediate: true,
      handler() {
        if (!hasRight(this.user, 'dashboard', 'view')) return;
        if (this.useAggregate) {
          if (this.dashboardData && this.dashboardData.presales_pipeline != null) this.pipelineData = { ...this.pipelineData, ...this.dashboardData.presales_pipeline };
          return;
        }
        if (this.dashboardData && this.dashboardData.presales_pipeline != null) { this.pipelineData = { ...this.pipelineData, ...this.dashboardData.presales_pipeline }; return; }
        this.fetchPresalesPipelineData();
      },
    },
    user: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (hasRight(newVal, 'dashboard', 'view')) {
          if (this.useAggregate) {
            if (this.dashboardData && this.dashboardData.presales_pipeline != null) this.pipelineData = this.dashboardData.presales_pipeline;
            return;
          }
          this.fetchPresalesPipelineData();
        } else {
          this.pipelineData = {
            total_leads: { count: 0, new_leads: 0, existing_leads: 0, progress_percentage: null },
            total_calls_done: { count: 0, progress_percentage: null },
            connected_calls: { count: 0, conversion_rate: null },
            qualified_interested_leads: { count: 0, conversion_rate: null },
            in_progress_leads: { count: 0, conversion_rate: null },
            site_visit_interested: { count: 0, conversion_rate: null },
          };
        }
      },
    },
  },
  methods: {
    hasRight, // Make the helper available in the template
    async fetchPresalesPipelineData() {
      if (!hasRight(this.user, 'dashboard', 'view')) return;
      if (this.useAggregate || (this.dashboardData && this.dashboardData.presales_pipeline != null)) {
        if (this.dashboardData && this.dashboardData.presales_pipeline != null) this.pipelineData = this.dashboardData.presales_pipeline;
        return;
      }
      try {
        const response = await dashboardGet(this.baseApi, this.accessToken, '/dashboard/crm/presales-pipeline', this.filters);
        this.pipelineData = response.data.data;
      } catch (error) {
        console.error('Error fetching presales pipeline data:', error);
        // Handle error
      }
    },
  },
};
</script>

<style scoped>
.presales-pipeline {
  margin-top: 20px;
}
</style>